<template>
  <div>
    <el-dialog title="上传"  :visible.sync="dialogShow"  width="70%"  :before-close="handlescreenshotCler"
      v-loading="loading"
      element-loading-text="正在上传中~"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div style="color: chocolate; text-align: center;font-size: 19px;padding: 20px 0px;font-family: cursive;"> 仅支持上传的文件格式: (jpg  ,  png  , word  , pdf  , PDF  , docx  , ppt  , xlsx)</div>
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action="#"
          :on-remove="handleRemove"
          :beforeUpload="beforeUpload"
          :file-list="fileLists"
          :http-request="handleUpload"
          :on-error="handleError"
          :auto-upload="true"
          :show-file-list="false"
          :limit="10000"
          accept="[.jpg,.png,.pdf,.PDF,.docx,.ppt,.xlsx,.zip]"
          multiple
          drag>
          <i class="el-icon-plus" style="font-size: 50px; line-height: 160px;"></i>

        </el-upload>

        <div v-if="fileListsPush.length > 0">
          <div v-for="(item,index) in fileListsPush" :key="index" style="margin-top: 10px;margin-left: 10px;display: flex;">
            <el-input v-model="item.name" ></el-input>
            <el-button style="width: 80px; margin-left: 10px;" icon="el-icon-delete" type="primary" size="small" @click="handleView('删除',item,index)">删除</el-button>
          </div>
        </div>

        <div  class="dialog-footer" style=" padding-bottom: 30px; margin-top: 80px;">
              <el-button @click="handlescreenshotCler" style="margin-right: 50px;">取 消</el-button>
              <el-button type="primary" @click="handlescreenshotSubmit">确 定</el-button>
        </div>

      </el-dialog>


  </div>
</template>

<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import 'animate.css'
import{createFileAPI,duplicateFileCheck} from "@/api/fileSpace.js"


export default {
  name: "Elupload",
  props: ['id'],
  data() {
    return {
      loading:false,

      screenshot:"",
      fileLists:[],


      dialogMessage:false,
      dialogMessageList:[],


      inputValue:"",

      dialogShow:true,

      url:"",
      name:"",

      showUrl:"",
      showUrlDialog:false,

      fileListsPush:[],

      ShowbaseCat:true,

    };
  },
  created() {

  },

  mounted(){
  },

  methods: {

    handlescreenshotCler(){
      this.$emit('handleEventElUpload',false)
    },

    handlescreenshotSubmit(){
      this.loading = true

      

      if(this.fileListsPush.length > 0){

            let data ={  fileName:this.fileListsPush[0].name, fileUrl: JSON.stringify(this.fileListsPush),   folderId:this.id, }
            createFileAPI(data).then(res=>{
              if(res.code === 200){
                    this.loading = false
                    this.$emit('handleEventElUpload',false,this.id)
                    // this.$message({ type: 'success', message: res.message })
                    this.$message({ type: 'success', message: '上传成功，请等待审批~'})
                }else{
                    this.loading = false
                    this.$message({ type: 'error', message: res.message })
                }
            })

        // let datas ={
        //   fileName:this.fileListsPush[0].name,
        //   folderId:this.id,
        // }
        // duplicateFileCheck(datas).then(res=>{
        //   
        //   if(res.data = true){
        //     let data ={
        //       fileName:this.fileListsPush[0].name,
        //       fileUrl:this.fileListsPush[0].url,
        //       folderId:this.id,
        //     }
        //     createFileAPI(data).then(res=>{
        //       if(res.code === 200){
        //         this.$emit('handleEventElUpload',false,this.id)
        //         this.$message({ type: 'success', message: res.message })
        //         }else{q
        //             this.$message({ type: 'error', message: res.message })
        //         }

        //     })
        //   }else{
        //     this.$message({ type: 'error', message: res.message })
        //   }
        // })


      }else{
        this.$message({ showClose: true,  message: '请选择文件',  type: 'warning' });
      }
    },

    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },

    beforeUpload(file) {
      loadingUtils.startLoading()
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".mp4"||
        this.getFileName(file.name) === ".excel"||
        this.getFileName(file.name) === ".doc"||
        this.getFileName(file.name) === ".ppt"||
        this.getFileName(file.name) === ".mp3"||
        this.getFileName(file.name) === ".xls"||
        this.getFileName(file.name) === ".xlsx"||
        this.getFileName(file.name) === ".pptx"||
        this.getFileName(file.name) === ".docx"||
        this.getFileName(file.name) === ".txt"||
        // this.getFileName(file.name) === ".jpg";
        this.getFileName(file.name) === ".jpg"||
        this.getFileName(file.name) === ".zip";
      const max20M = file.size / 1024 / 1024 < 1000;
      if (!fileExtensions) {
        this.$message.error("上传文件类不合格式!");
        loadingUtils.endLoading();
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 1000MB!");
        loadingUtils.endLoading();
      }
      this.fileLists.push(file);
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      put(`mz_pc/${objName}`, option.file).then((res) => {

        let indexs = option.file.name.lastIndexOf(".")
        let file = { url: res.url, name: option.file.name.substring(0, indexs) }

        this.fileListsPush.push(file)

        loadingUtils.endLoading();
        this.screenshot = res.url
        signatureUrl(`mz_pc/${objName}`).then((res) => {

        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;


      this.fileListsPush = this.fileListsPush.filter((itme)=>{
        return itme.name !== fileList[0].name
      })

      this.screenshot = ""
    },

    handleError(){
      loadingUtils.endLoading();
    },

    handleView(type, e, index){

      if(type === '删除'){
        this.fileListsPush.splice(index, 1)
      }

    },



  },

  beforeDestroy(){

  }

};
</script>


<style scoped>


.btns{
  background-color: rgb(78, 140, 255);
  border-color: rgb(78, 140, 255);
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/FileSpace/Elupload.vue